export default {
  title: '代理赚钱',
  myCommission: '我的佣金',
  teamSize: '团队人数',
  teamDeposit: '团队充值',
  teamContribute: '团队贡献',
  teamBet: '团队投注',
  newYesterday: '昨日新增',
  newMonth: '月新增',
  activeMonth: '月活跃',
  teamWinLoss: '团队输赢',
  serviceCenter: '服务中心',
  members: '成员管理',
  memberData: '成员数据',
  memberProxyDeposit: '代理代存',
  liveConsume: '直播消费',
  memberSearchPlaceholder: '下级代理 ID',
  memberSearch: '查询',
  memberColUser: '用户',
  memberColContrib: '贡献',
  memberColAction: '操作',
  memberId: 'ID: {id}',
  memberEdit: '编辑成员',
  memberEmpty: '没有找到成员数据',
  memberEmptyHint: '请核对下级代理 ID 后重新查询',
  memberNotFound: '未找到该直属成员',
  memberDataUpdated: '成员数据已更新',
  memberLoadMore: '加载更多',
  memberLoading: '加载中…',
  memberNoMore: '没有更多了',
  materials: '推广素材',
  materialsInvitePrefix: '邀请好友加入',
  materialsInviteSub: '你与好友都能轻松赚佣金',
  materialsCardTitle: '{brand} 专属邀请',
  materialsCardDesc: '分享你的专属链接，好友注册后自动绑定',
  materialsQrHint: '请使用手机浏览器扫码进入',
  materialsCopyLink: '复制链接',
  materialsSaveQr: '保存二维码',
  materialsSaveOk: '二维码已保存',
  materialsSaveFail: '保存失败，请长按图片保存',
  gameRecords: '游戏记录',
  gameRecordTime: '时间',
  gameRecordMember: '会员账号',
  gameRecordMemberPlaceholder: '请输入会员 ID',
  gameRecordUpdated: '游戏记录已按所选条件更新',
  gameRecordBetTotal: '下注金额：',
  gameRecordProfitTotal: '盈亏金额：',
  gameRecordBetCount: '下单注量',
  gameRecordBetAmount: '下单金额',
  gameRecordWinAmount: '中奖金额',
  gameRecordViewDetail: '查看详情 >',
  gameRecordEmpty: '暂无游戏记录',
  gameRecordEmptyHint: '没有找到该会员的平台记录',
  gameRecordBackSummary: '返回平台汇总',
  gameRecordOrdersTitle: '{name} 注单',
  gameRecordBetTime: '下注时间',
  gameRecordBetContent: '下注内容',
  gameRecordOrderStatus: '订单状态',
  gameRecordOrderNo: '订单编号',
  gameRecordSettled: '已结算',
  gameRecordPending: '待结算',
  gameRecordCancelled: '已取消',
  gameRecordLoading: '加载中…',
  gameRecordLoadMore: '加载更多',
  gameRecordNoMore: '没有更多了',
  withdrawNow: '立即提现',
  incomeWithdraw: '收入提现',
  withdrawRecords: '提现记录',
  withdrawNotice: '请仔细核对收款信息，转入他人账户将无法追回',
  withdrawableAmount: '可提现金额',
  withdrawingAmount: '提现中金额',
  transferringAmount: '转入中金额',
  withdrawToAccount: '提现到账户',
  withdrawToAccountSub: '转到外部收款账户',
  withdrawToBalance: '转入账户余额',
  withdrawToBalanceSub: '直接转入账户余额',
  withdrawAmount: '提现金额',
  withdrawManageAccount: '管理提现账户',
  withdrawAll: '全部',
  withdrawArrivalAmount: '可到金额: {amount}',
  withdrawSelectAccount: '请选择提现账户',
  withdrawChangeAccount: '更改',
  withdrawPickTitle: '选择提现账户',
  withdrawAddMethod: '添加提现方式',
  withdrawNoAccount: '暂无提现账户',
  withdrawScheduleHint: '每月 1—31 号可提交提现申请，收益将在 1—5 天统一发放。',
  withdrawAmountRequired: '请输入提现金额',
  withdrawExceed: '提现金额不能超过可提现金额 {amount}',
  withdrawExceedLimit: '提现金额不能超过单笔限额 {amount}',
  withdrawBelowMin: '提现金额不能低于 {amount}',
  withdrawSelectAccountRequired: '请选择提现账户',
  withdrawSubmitted: '提现申请已提交',
  transferSubmitted: '已转入账户余额',
  transferProcessing: '转入中',
  withdrawAccounts: '管理提现账户',
  waMultiSelect: '多选',
  waDone: '完成',
  waLockLabel: '账户已锁定',
  waLockHint: '开启多选后可管理此账户',
  waDelete: '删除账户',
  waDeleteSuccess: '{name} 账户已删除',
  waAddAccount: '添加账户',
  waEmpty: '暂无提现账户',
  waEmptyHint: '添加收款账户后即可提交提现申请',
  waSheetTitle: '添加收款方式',
  waFormTitle: '添加 {name}',
  waNoticeAccount: '请仔细核对收款账号，转入他人账户将无法追回',
  waNoticeAddress: '请仔细核对钱包地址，转入他人地址将无法追回',
  waNoticeBank: '请仔细核对银行卡信息，转入他人账户将无法追回',
  waNoticeBankCard: '请仔细核对卡号，转入他人账号将无法追回',
  waChainType: '链类型',
  waNetwork: '主网',
  waCurrency: '货币类型',
  waRegion: '开户地区',
  waRegionPh: '选择开户地区',
  waRegionRequired: '请先选择一个地区开户',
  waPickRegion: '选择地区',
  waPickBank: '选择开户银行',
  waBankSearchPh: '请输入搜索关键字',
  waBankAccount: '银行账号',
  waBankAccountPh: '请输入收款账号',
  waBranch: '开户网点',
  waBranchPh: '请输入开户网点',
  waBankNamePh: '请选择开户银行',
  waRegionCn: '中国',
  waRegionJp: '日本',
  waRegionTw: '台湾',
  waRegionHk: '香港',
  waRegionMo: '澳门',
  waRegionSg: '新加坡',
  waBankBoc: '中国银行',
  waBankIcbc: '工商银行',
  waBankCcb: '建设银行',
  waBankAbc: '农业银行',
  waBankBocom: '交通银行',
  waBankCitic: '中信银行',
  waBankCmb: '招商银行',
  waBankSpdb: '浦发银行',
  waBankCib: '兴业银行',
  waBankCmbc: '民生银行',
  waBankCeb: '光大银行',
  waBankHxb: '华夏银行',
  waBankPingan: '平安银行',
  waHolder: '真实姓名',
  waHolderPh: '请输入真实姓名',
  waCardHolder: '持卡人姓名',
  waCardHolderPh: '请输入持卡人姓名',
  waBankName: '开户银行',
  waCardNo: '银行卡号',
  waCardNoPh: '请输入银行卡号',
  waAccount: '收款账号',
  waAccountPh: '请输入收款账号',
  waAddress: '钱包地址',
  waAddressPh: '请输入钱包地址',
  waUsdtAddressPh: 'USDT({network})钱包地址',
  waPaste: '粘贴',
  waPasteFail: '粘贴失败，请手动输入',
  waSubmit: '立即添加',
  waAddSuccess: '{name} 账户已添加',
  waFieldRequired: '请输入{label}',
  waSelectFieldRequired: '请选择{label}',
  waChOkpay: 'OKpay',
  waChGopay: 'GOpay',
  waChBank: '银行卡',
  waChUsdt: 'USDT',
  waChBobi: '波币钱包',
  waChKdou: 'K豆钱包',
  waChWanbi: '万币钱包',
  waChJjpay: 'JJPAY',
  waChVippay: 'VIPpay',
  transferAmount: '转入金额',
  transferRealtime: '实时到账',
  transferAmountPlaceholder: '可转入金额 {amount}',
  transferArrivalBalance: '可到账户余额：{amount}',
  transferToAccount: '转入账户',
  transferUnchangeable: '不可更改',
  transferToBalancePre: '转入到',
  transferToBalanceName: '账户余额',
  transferTagRealtime: '实时到账',
  transferTagNoFee: '免手续费',
  transferTagNoBind: '无需绑定账户',
  transferTagParity: '1:1 等额到账',
  transferDesc: '转入账户余额说明：收入直接转入账户余额，可立即用于游戏，无需提现审核。',
  transferHelp: '说明',
  transferSubmit: '确认转入账户余额',
  billRecords: '账单明细',
  billTabRecharge: '充值',
  billTabWithdraw: '提现',
  billTabRebate: '返水',
  billTabRedpacket: '红包',
  billTabReward: '奖励',
  billTypeFilter: '交易类型',
  billChannel: '渠道',
  billSource: '来源',
  billTime: '时间',
  billChannelBank: '银行卡',
  billChannelCrypto: '数字货币',
  billChannelBalance: '账户余额',
  billWithdrawApply: '提现申请',
  billPromoWithdraw: '推广提现申请',
  billTypeAllRecharge: '全部充值',
  billTypeBankRecharge: '银行卡充值',
  billTypeCryptoRecharge: '数字货币充值',
  billTypeAllWithdraw: '全部提现',
  billTypeWithdrawAccount: '提现到账户',
  billTypeTransferBalance: '转入账户余额',
  billTypeAllRebate: '全部返水',
  billTypeRealtimeRebate: '实时返水',
  billRebateSourceAll: '全部',
  billTypeAllRedpacket: '全部红包',
  billTypeSendRedpacket: '发送红包',
  billTypeClaimRedpacket: '领取红包',
  billTypeAllReward: '全部奖励',
  billTypeChestReward: '宝箱任务',
  billTypeSignInReward: '签到奖励',
  billStatus: {
    received: '已到账',
    unprocessed: '未处理',
    reviewing: '审核中',
    success: '成功',
    failed: '失败',
  },
  billEmpty: '暂无账单记录',
  billEmptyTitle: '暂无账单记录~',
  billEmptyHint: '你的账单记录已经被清空，新的交易记录会显示在这里。',
  billFilterEmpty: '暂无账单记录',
  billLoading: '加载中…',
  billLoadMore: '加载更多',
  billMore: '更多',
  billDeleteHint: '这样将会删除你目前所有的账单明细',
  billDeleteNoData: '当前列表无数据',
  billDeleteAll: '删除全部账单',
  billCancel: '取消',
  billConfirm: '确认',
  billDeleteConfirmTitle: '确认删除全部账单？',
  billDeleteConfirmPrefix: '删除后将',
  billDeleteConfirmEm: '无法恢复',
  billDeleteConfirmSuffix: '，请谨慎操作。',
  billDeleteSuccess: '删除成功',
  commissionReport: '佣金报表',
  reportTime: '时间',
  reportTo: '至',
  reportTotal: '{period}总佣金 共 {count} 笔',
  reportTotalCustom: '所选日期总佣金 共 {count} 笔',
  reportDirectCommission: '直属佣金',
  reportIndirectCommission: '非直属佣金',
  reportGameCommission: '游戏佣金',
  reportLiveCommission: '直播佣金',
  reportDetails: '佣金明细',
  reportDetailsSub: '查看每一笔返佣记录',
  reportColNick: '昵称',
  reportColTime: '返佣时间',
  reportColType: '返佣类型',
  reportColAmount: '返佣金额',
  reportBasisTurnover: '流水返佣',
  reportBasisNgr: '净输赢返佣',
  reportBasisRakeback: '返水分成返佣',
  reportSourceDaily: '日结返佣',
  reportSourceAdjustment: '迟到修正',
  reportDepthDirect: '直属下级',
  reportTypeLottery: '彩票',
  reportTypeGame: '游戏',
  reportTypeLive: '直播',
  reportEmpty: '暂无佣金记录',
  reportEmptyHint: '团队产生有效贡献后将按结算周期入账',
  reportDetailEmpty: '暂无佣金明细',
  reportDetailEmptyHint: '所选日期内暂未产生返佣',
  reportPickDate: '选择日期',
  reportPickStart: '请选择开始日期',
  reportPickEnd: '请选择结束日期',
  reportRangeSelected: '日期区间已选择',
  reportHeaderDate: '{m}月{d}日周{w}',
  reportHeaderDateEn: '{w}, {month} {d}',
  reportMonthTitle: '{y}年{m}月',
  reportMonthTitleEn: '{month} {y}',
  reportPrevMonth: '上一月',
  reportNextMonth: '下一月',
  reportCancel: '取消',
  reportConfirm: '确定',
  commissionPlan: '佣金方案',
  planFilter: '筛选',
  planConfirm: '确认',
  planAll: '全部',
  planAllLabel: '全部方案',
  planSummary: '{name} · {count}',
  planTiers: '{n} 档',
  planColPlan: '方案',
  planColTrigger: '触发流水',
  planColCap: '返佣上限',
  planColRatio: '返佣比例',
  planEmpty: '暂无佣金方案',
  bindRelation: '绑定上下级',
  bindSubTitle: '绑定下级',
  bindSubId: '下级 ID',
  bindCode: '绑定码',
  bindSubIdPlaceholder: '请输入下级 ID',
  bindCodePlaceholder: '请输入绑定码',
  bindSubIdRequired: '请输入下级 ID',
  bindCodeRequired: '请输入绑定码',
  submitting: '提交中…',
  bindConfirm: '确认绑定',
  bindSuccess: '绑定成功',
  bindSuccessDesc: '下级 ID {id} 已成功绑定（绑定码 {code}）',
  bindViewRelation: '查看上下级',
  bindTipsTitle: '温馨提示',
  bindTip1: '代理可通过此功能找回绑定未成功的下级会员。',
  bindTip2: '绑定码可在“上下级 → 我的名片”中获取，已经绑定后不再显示。',
  relation: '上下级',
  relationMyCard: '我的名片',
  relationMySuperior: '我的上级',
  relationId: 'ID: {id}',
  relationBindCode: '绑定码: {code}',
  relationCopyCard: '复制名片',
  relationNoSuperior: '暂无上级',
  exclusiveCs: '专属客服',
  comingSoon: '功能即将开放',
  teamStatsTruncated: '数据量过大，请查看佣金报表',
}
